import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import localeData from 'dayjs/plugin/localeData';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/es';

// Register plugins
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale('es');

export { dayjs };

/** 
 * Parse a database timestamp (which is stored as UTC midnight)
 * and return a dayjs object strictly in UTC so it doesn't drift.
 */
export function parseDBDate(dateStr: string | Date | number | undefined | null) {
  if (!dateStr) return dayjs.utc();
  return dayjs.utc(dateStr);
}

// Month names in Spanish (matching VBA ENERO-DICIEMBRE pattern)
export const MONTH_NAMES = [
  'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
  'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE',
] as const;

/** Get Spanish month name from 0-indexed month number */
export function getMonthName(month: number): string {
  return MONTH_NAMES[month] ?? '';
}

/** Format a YYYY-MM period string to human readable Spanish */
export function formatPeriod(period: string): string {
  const [year, month] = period.split('-');
  const monthIdx = parseInt(month, 10) - 1;
  return `${getMonthName(monthIdx)} ${year}`;
}

/** Get current period as YYYY-MM */
export function getCurrentPeriod(): string {
  return dayjs().format('YYYY-MM');
}

/** Check if a date falls within a rate validity period */
export function isWithinRateValidity(
  date: number,
  emisionTimestamp: number,
  vencimientoTimestamp: number,
): boolean {
  // Rate is valid from emision+1 day to vencimiento (inclusive)
  const emisionPlusOne = dayjs(emisionTimestamp).add(1, 'day').startOf('day').valueOf();
  return date >= emisionPlusOne && date <= vencimientoTimestamp;
}
